import { Component, Input, OnChanges, OnInit } from '@angular/core'
import { formatDateUsingString } from '@ui/utils'
import { NgStyle } from '@angular/common'

@Component({
	selector: 'time-component-inner',
	template: `
		<div [ngStyle]="{ display: 'inline-block' }">{{ formattedTime }}</div>
	`,
	imports: [NgStyle],
})
export class TimeComponent implements OnInit, OnChanges {
	@Input() private readonly date: string

	@Input() private readonly timezone: string = 'utc'

	public formattedTime: string

	public ngOnInit() {
		this.setUpComponent()
	}

	public ngOnChanges() {
		this.setUpComponent()
	}

	private readonly setUpComponent = () => {
		this.formattedTime = formatDateUsingString(
			this.date,
			this.timezone,
			'HH:mm',
		)
	}
}
